(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pool-calculator"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.pool-calculator');
  var lengthInput = document.getElementById('calcLength');
  var widthInput = document.getElementById('calcWidth');
  var depthInput = document.getElementById('calcDepth');
  if (!section || !lengthInput) return;

  /* Merchant-tunable constants injected from the section schema via
     data-* attributes (this bundled script cannot render Liquid).
     Fallbacks mirror the schema defaults. */
  var cfg = {
    turnoverHours: parseFloat(section.dataset.turnoverHours) || 8,
    chlorineRate: parseFloat(section.dataset.chlorineRate) || 10,   /* g per m3 per week */
    seasonWeeks: parseFloat(section.dataset.seasonWeeks) || 13,
    chlorinePackageG: parseFloat(section.dataset.chlorinePackage) || 5000,
    algaeDoseMl: parseFloat(section.dataset.algaeDose) || 5,        /* ml per m3 per week */
    algaeBottleMl: parseFloat(section.dataset.algaeBottle) || 1000
  };

  var currentShape = 'rect';

  function formatMoney(cents) {
    return '₪' + Math.round(cents / 100).toLocaleString('he-IL');
  }

  /* Seasonal quantity per product category, derived from the computed
     volume and the merchant's dosing settings:
     - chlorine: total season grams / package size
     - algae:    total season ml / bottle size
     - ph:       ~1 kg-class unit per 50 m3 per season
     - equipment (pump/cover/cleaning): one unit, not volume-driven */
  function getRecommendedQuantity(category, volume) {
    switch (category) {
      case 'chlorine':
        return Math.max(1, Math.ceil((volume * cfg.chlorineRate * cfg.seasonWeeks) / cfg.chlorinePackageG));
      case 'algae':
        return Math.max(1, Math.ceil((volume * cfg.algaeDoseMl * cfg.seasonWeeks) / cfg.algaeBottleMl));
      case 'ph':
        return Math.max(1, Math.ceil(volume / 50));
      case 'pump':
      case 'cover':
      case 'cleaning':
        return 1;
      default:
        return Math.max(1, Math.min(3, Math.ceil(volume / 30)));
    }
  }

  function updateRecommendations(volume) {
    var products = document.querySelectorAll('.pool-calculator .rec-product');
    var totalCents = 0;
    products.forEach(function(p) {
      var category = p.dataset.category;
      var qty = getRecommendedQuantity(category, volume);
      var priceCents = parseInt(p.dataset.productPrice) || 0;
      var qtyNum = p.querySelector('.qty-num');
      var qtyMult = p.querySelector('.qty-multiplier');
      if (qtyNum) qtyNum.textContent = qty;
      if (qtyMult) qtyMult.textContent = qty;
      totalCents += priceCents * qty;
      p.dataset.recommendedQty = qty;
    });
    var totalEl = document.getElementById('recTotalValue');
    if (totalEl) totalEl.textContent = formatMoney(totalCents);
  }

  /* Volume by pool shape (metric, m3) - the standard formulas used by
     professional pool volume calculators:
     rect: L*W*D | round: pi/4 * d^2 * D | oval: pi/4 * L*W*D */
  function computeVolume(length, width, depth) {
    if (currentShape === 'round') return (Math.PI / 4) * length * length * depth;
    if (currentShape === 'oval') return (Math.PI / 4) * length * width * depth;
    return length * width * depth;
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  /* QA DEV-12: each field must be a number inside its min/max (the width
     is ignored for round pools). Invalid fields get a Hebrew message; while
     any is invalid no result or product recommendation is shown. */
  var fieldNames = { calcLength: 'האורך', calcWidth: 'הרוחב', calcDepth: 'העומק' };
  function validateField(input) {
    var group = input.closest('.input-group');
    var skip = input === widthInput && currentShape === 'round';
    var min = parseFloat(input.min);
    var max = parseFloat(input.max);
    var raw = input.value.trim();
    var value = parseFloat(raw);
    var name = input === lengthInput && currentShape === 'round' ? 'הקוטר' : fieldNames[input.id];
    var message = '';
    if (!skip) {
      if (raw === '' || isNaN(value)) message = 'יש להזין את ' + name + ' במטרים.';
      else if (value < min || value > max) message = 'יש להזין ' + name + ' בין ' + min + ' ל-' + max + ' מטרים.';
    }
    var error = group.querySelector('.calc-field-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'calc-field-error';
      error.id = input.id + '-error';
      group.appendChild(error);
    }
    error.textContent = message;
    error.hidden = !message;
    if (message) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', error.id);
    } else {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
    return !message;
  }

  function calculate() {
    var valid = [lengthInput, widthInput, depthInput].map(validateField).every(Boolean);
    section.classList.toggle('calc--invalid', !valid);
    if (!valid) {
      ['outVolume', 'outLiters', 'outCirculation', 'outChlorine', 'outTablets', 'recVolume'].forEach(function(id) {
        setText(id, '—');
      });
      return;
    }

    var length = parseFloat(lengthInput.value) || 0;
    var width = parseFloat(widthInput.value) || 0;
    var depth = parseFloat(depthInput.value) || 0;
    var volume = computeVolume(length, width, depth);

    /* One decimal for small pools, whole numbers above 10 m3. */
    var volumeText = volume < 10 ? (Math.round(volume * 10) / 10).toLocaleString('he-IL') : Math.round(volume).toLocaleString('he-IL');
    var weeklyChlorineG = Math.round(volume * cfg.chlorineRate);

    setText('outVolume', volumeText);
    setText('outLiters', Math.round(volume * 1000).toLocaleString('he-IL'));
    /* Pump flow for a full turnover every cfg.turnoverHours hours. */
    setText('outCirculation', Math.max(1, Math.ceil(volume / cfg.turnoverHours)));
    setText('outTurnover', cfg.turnoverHours);
    setText('outChlorine', weeklyChlorineG.toLocaleString('he-IL'));
    setText('outTablets', Math.max(1, Math.round(weeklyChlorineG / 200)));
    setText('recVolume', volumeText);
    updateRecommendations(volume);
  }

  /* Shape selector: toggles the active pill, hides the width input for
     round pools and swaps the length label to "diameter". */
  var widthGroup = section.querySelector('[data-width-group]');
  var lengthLabel = section.querySelector('label[for="calcLength"]');
  section.querySelectorAll('.calc-shape').forEach(function(btn) {
    btn.addEventListener('click', function() {
      currentShape = btn.dataset.shape;
      section.querySelectorAll('.calc-shape').forEach(function(b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (widthGroup) widthGroup.style.display = currentShape === 'round' ? 'none' : '';
      if (lengthLabel) {
        lengthLabel.textContent = currentShape === 'round'
          ? lengthLabel.dataset.labelRound
          : lengthLabel.dataset.labelDefault;
      }
      calculate();
    });
  });

  [lengthInput, widthInput, depthInput].forEach(function(input) {
    input.addEventListener('input', calculate);
  });
  calculate();

  /* ------------------------------------------------------------------
     CART CODE BELOW IS UNCHANGED (cart freeze): same /cart/add.js call,
     same button wiring and states as the previous version.
     ------------------------------------------------------------------ */
  function addToCart(items, btn, originalText, redirectAfter) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, status: r.status, data: data }; });
    }).then(function(result) {
      if (result.ok) {
        if (redirectAfter) {
          window.location.href = '/cart';
        } else if (btn) {
          var qty = items[0] ? items[0].quantity : 1;
          btn.textContent = '✓ נוסף (' + qty + ')';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2500);
        }
      } else {
        console.error('Cart add error:', result.data);
        var msg = result.data && result.data.description ? result.data.description : 'שגיאה';
        if (btn) {
          btn.textContent = msg.substring(0, 30);
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 3000);
        }
      }
    }).catch(function(err) {
      console.error('Network error:', err);
      if (btn) {
        btn.textContent = 'שגיאת רשת';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2500);
      }
    });
  }

  document.querySelectorAll('.pool-calculator .rec-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var product = btn.closest('.rec-product');
      if (!product) return;
      var productId = parseInt(product.dataset.productId);
      var qty = parseInt(product.dataset.recommendedQty) || 1;
      if (!productId) {
        console.error('No product ID found');
        return;
      }
      var originalText = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;
      addToCart([{ id: productId, quantity: qty }], btn, originalText, false);
    });
  });

  var addAllBtn = document.getElementById('recAddAllBtn');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', function() {
      var items = [];
      document.querySelectorAll('.pool-calculator .rec-product').forEach(function(p) {
        var id = parseInt(p.dataset.productId);
        var qty = parseInt(p.dataset.recommendedQty) || 1;
        if (id) items.push({ id: id, quantity: qty });
      });
      if (items.length === 0) return;
      var originalText = addAllBtn.textContent;
      addAllBtn.textContent = 'מוסיף...';
      addAllBtn.disabled = true;
      addToCart(items, addAllBtn, originalText, true);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
